"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
 mutation cancelOfferedTicket($orderId: String) {
  cancelOfferedTicket(orderId: $orderId){
    _id
    tickets{
        _id
      name
      ticketTypeId
      ticketTierId
      price 
      state
    }
  }
}
`;
exports.default = mutation;
//# sourceMappingURL=cancelTickets.mutation.js.map